export default __webpack_public_path__ + "2c003171949334cbdd493f462661a60d.png";